export default "__VITE_ASSET__29fe01e3__"